import {httpGet, httpPut, httpDelete, httpPost, httpPostForm, httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class PlanReachApi {

    static QUERY_PLAN_REACH_LIST = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/pd-wb-impl-reach/list";
    static PLAN_REACH_DETAIL = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/pd-wb-impl-reach/detail";
    static PLAN_REACH_EXPORT_DATA = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/pd-wb-impl-reach/exportData";

    static list(params) {
        return httpGet(PlanReachApi.QUERY_PLAN_REACH_LIST, params);
    }

    static detail(params) {
        return httpGet(PlanReachApi.PLAN_REACH_DETAIL, params);
    }

    static exportData(params) {
        return httpDownload(PlanReachApi.PLAN_REACH_EXPORT_DATA, params);
    }

}